import moment from 'moment';

export function calculateAge(birthDateStr, referenceDate = moment()) {
  if (!birthDateStr) {
    return null;
  }

  // 👉 Verificación previa: formato debe ser YYYY-MM-DD o DD/MM/YYYY
  const isValidPattern =
    /^\d{4}-\d{2}-\d{2}$/.test(birthDateStr) ||
    /^\d{2}\/\d{2}\/\d{4}$/.test(birthDateStr);

  if (!isValidPattern) {
    return null;
  }

  let birth = moment(birthDateStr, moment.ISO_8601, true);

  if (!birth.isValid()) {
    birth = moment(birthDateStr, 'DD/MM/YYYY', true);
  }

  if (!birth.isValid()) {
    return null;
  }

  const reference = moment(referenceDate).startOf('day');
  const age = reference.diff(birth.startOf('day'), 'years');

  return Math.max(0, age);
}
